<template>
  <c360-what-is-new-modal :enabled="enabled" :content="articleBody" @close="onClose" />
</template>

<script>
  import { C360WhatIsNewModal } from '../../../components/WhatIsNew';
  import { isWhatsNewDialogAvailable, whatsNewArticle, recordWhatsNewDialogView } from '../model';
  import { isDateAfter } from '../../../shared/utils/date';

  export default {
    name: 'C360WhatIsNew',

    inject: ['$c360', '$can', '$accessTokenProvider'],

    components: {
      C360WhatIsNewModal,
    },

    data() {
      return {
        enabled: false,
        articleBody: '',
        dialogId: null,
      };
    },

    async mounted() {
      const token = this.$accessTokenProvider();
      await this.checkAndShowWhatsNewDialog(token);
    },

    computed: {
      accessTokenProvider() {
        return this.$accessTokenProvider();
      },
    },

    watch: {
      async accessTokenProvider(token) {
        await this.checkAndShowWhatsNewDialog(token);
      }
    },

    methods: {
      async checkAndShowWhatsNewDialog(token) {
        const { enabled, end, userShouldSeeIt, id } = await isWhatsNewDialogAvailable(
          this.$c360.product,
          token,
        );

        const isOutdated = isDateAfter(new Date(), new Date(end));
        const shouldShowDialog = enabled && !isOutdated && userShouldSeeIt;

        if (shouldShowDialog) {
          const { body } = await whatsNewArticle(this.$c360.product, token);
          const isEnabled = shouldShowDialog && !!body;
          this.dialogId = id;
          this.setDialog(isEnabled, body);
        }
      },

      async onClose() {
        const token = this.$accessTokenProvider();
        await recordWhatsNewDialogView(this.dialogId, token);
        this.enabled = false;
      },

      setDialog(enabled, body) {
        this.enabled = enabled;
        this.articleBody = body;
      }
    },
  };
</script>
